import React from 'react';
import { ExternalLink } from 'lucide-react';
import SectionUnlock from '../components/SectionUnlock';

const CertificationsSection = ({ unlockedSections }) => {
  return (
    <section id="certifications" className="py-20 bg-white relative">
      <SectionUnlock sectionId="certifications" unlockedSections={unlockedSections}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Certifications & Achievements</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Professional certifications and key accomplishments that demonstrate my commitment to excellence
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-8 rounded-2xl group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                <div className="w-3 h-3 bg-orange-600 rounded-full animate-pulse"></div>
                Professional Certifications
              </h3>
              <div className="bg-white p-6 rounded-lg border border-orange-200 shadow-sm">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-orange-600 font-bold text-lg">AWS</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-800 text-lg">AWS Generative AI Certification</h4>
                    <p className="text-sm text-gray-600">Issued by SCS (Singapore Computer Society)</p>
                  </div>
                </div>
                <a 
                  href="https://dashboard.accredify.io/public/assertions/d0a7d68e-15ea-4882-b030-a9391238b532"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-orange-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-700 transition-colors"
                >
                  <ExternalLink size={16} />
                  Verify Certificate
                </a>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
                Key Achievements
              </h3>
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg border border-blue-200 shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
                      <span className="text-yellow-600">🏆</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Particpating in many hackathons</h4>
                      <p className="text-sm text-gray-600">Although we did not win or missed by runner up, hackathons made me think beyond what i was used to in school</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white p-4 rounded-lg border border-blue-200 shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                      <span className="text-green-600">👥</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Secured Internship at MNC @ Mercedes-Benz</h4>
                      <p className="text-sm text-gray-600">Firstly, I earned internship through competitive technical assessment process. Secondly, I navigated complex project challenges and delivered high-quality results, earning an "excellent" final evaluation.</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-4 rounded-lg border border-blue-200 shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                      <span className="text-purple-600">🎓</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">Academic Aptitude</h4>
                      <p className="text-sm text-gray-600">Maintained GPA - Always improving</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionUnlock>
    </section>
  );
};

export default CertificationsSection;